
 
import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";
import Resumen from "@/components/sobrevivencia/Resumen.vue";
import { formatFechaAfpSiembra } from "@/utils/HelperFunctions";
import AfiliadoService from "@/services/AfiliadoService";
@Component({
  components: {
    Resumen,
  },
})
export default class ResumenSobrevivencia extends Vue{
  

}
